import React from 'react';
import './OnboardingStepRedesign.css';

export const OnboardingCongratulationsStep = ({ email }) => (
  <div className="justify-content-center pt-2 text-center ">
    <div className="red-step-title mb-4">That's a wrap!</div>
    <div className="justify-content-center mx-auto">
      <div className="onboarding-step-redesign__confirm-email onboarding-step-redesign__confirm-email__top mx-auto">
        Our account team will email you within 2 hours.
      </div>
      <div className="onboarding-step-redesign__confirm-email onboarding-step-redesign__confirm-email__bottom  mx-auto">
        In the interim, you can track your submission or fill in additional details on your project dashboard.
      </div>
      <div className="">
        <a href="/">
          <button className="btn-to-dashboard">
            <div className="text">Сontinue to Project Dashboard</div>
          </button>
        </a>
      </div>
    </div>
  </div>
);



// WEBPACK FOOTER //
// ./src/containers/OnboardingRedesign/OnboardingCongratulationsStep.js